{
	"activating": "Activating…",
	"description": "Set a password to finish activating your account.",
	"email": "Email",
	"failed": {
		"link_closed": {
			"description": "It expired, was revoked or was used while this page was open. Ask whoever invited you to send a new one.",
			"title": "This invitation is no longer usable"
		},
		"password_rejected": {
			"description": "It does not meet the console's password rules. Choose another one: nothing has changed yet.",
			"title": "That password was refused"
		},
		"provider_unavailable": {
			"description": "Your invitation is untouched. Submit the form again in a moment.",
			"title": "We could not set your password"
		},
		"rate_limited": {
			"description": "Wait a few minutes before trying again.",
			"title": "Too many attempts"
		},
		"unavailable": {
			"description": "Something went wrong. Submit the form again.",
			"title": "We could not finish the activation"
		}
	},
	"first_name": "First name",
	"first_name_required": "Enter your first name.",
	"handing_over": {
		"description": "Enter the password you have just chosen.",
		"signed_in": "Taking you to the console…",
		"title": "Taking you to sign in…"
	},
	"last_name": "Last name",
	"last_name_required": "Enter your last name.",
	"loading": "Checking your invitation…",
	"password": "Password",
	"password_policy": {
		"rules": {
			"digits": "contains at least {{value}} digit",
			"length": "is at least {{value}} characters long",
			"lowerCase": "contains at least {{value}} lowercase letter",
			"passwordHistory": "is not one of your last {{value}} passwords",
			"specialChars": "contains at least {{value}} special character",
			"upperCase": "contains at least {{value}} capital letter"
		},
		"title": "The console requires a password that:"
	},
	"password_required": "Choose a password.",
	"refused": {
		"already_used": {
			"description": "Your access is already active. Sign in with your email and the password you chose.",
			"go_to_login": "Go to sign in",
			"title": "Invitation already used"
		},
		"expired": {
			"description": "Invitations are valid for a limited time. Ask whoever invited you to send a new one.",
			"title": "This invitation has expired"
		},
		"invalid": {
			"description": "Check that you opened the whole link from the email. If it still fails, ask whoever invited you to send a new one.",
			"title": "This invitation link does not work"
		},
		"rate_limited": {
			"description": "Wait a few minutes, then open the link from the email again.",
			"title": "Too many attempts"
		},
		"unavailable": {
			"description": "Nothing about your invitation has changed. Reload the page to try again.",
			"title": "We could not check your invitation"
		}
	},
	"submit": "Set password and continue",
	"title": "You have been invited to the console"
}
